import singleAdapter from '../program/adapter'
import dayjs from 'dayjs'
import { NEED_TO_RE_FILTER_STATISTICS } from "./config"
import { getCoordinateObject } from '../../utils'

// Program status id
const ONGOING = 2
const COMPLETED = 4
const autoStatusChecking = true

const subAdapter = {
  statistic: {
    responseBodyToRender(input, totalRegistered){
      let output = {}

      if(input && input.length > 0){
        let data = []
        let total = 0

        if(NEED_TO_RE_FILTER_STATISTICS === false){
          total = totalRegistered
        }

        for (let index = 0; index < input.length; index++) {
          const d = input[index];
          const name = d[0]
          const value = d[1]

          data.push({name, value})

          if(NEED_TO_RE_FILTER_STATISTICS === true){
            total += value
          }
        }

        // Sort from largest to smallest value
        const sorted = data.sort((a, b) => b.value - a.value)

        output = { data: sorted, total }
      }

      return output
    }
  }
}

const adapter = {
  responseBodyToRender(payload = []){
    let result = [];

    if(payload && payload.length > 0){
      for (let index = 0; index < payload.length; index++) {
        const program = payload[index];

        result.push(singleAdapter.responseBodyToRender(program))
      }
    }

    return result;
  },
  responseBodyToOptions(payload){
    let result = [];

    if(payload && payload.length > 0){
      for (let index = 0; index < payload.length; index++) {
        const element = payload[index];
        result.push(singleAdapter.responseBodyToOptions(element))
      }
    }

    return result
  },
  responseBodyToByProvince(payload){
    let programByProvince = {}

    if(payload && payload.length > 0){
      // Loop through all programs
      for (let index = 0; index < payload.length; index++) {
        const program = payload[index];
        const { lokasi } = program

        const programHaveLocations = lokasi && lokasi.length > 0
        if(programHaveLocations){
          // Save loop result
          // Reduce by province
          programByProvince = reduceByProvince(program, programByProvince)
        }
      }
    }

    return programByProvince
  },
  responseBodyToByProvinceByStatus(payload){
    let programByProvinceByStatus = {}

    if(payload && payload.length > 0){
      for (let index = 0; index < payload.length; index++) {
        const program = payload[index];
        const { lokasi } = program

        const programHaveLocations = lokasi && lokasi.length > 0
        if(programHaveLocations){
          programByProvinceByStatus = reduceByProvinceByStatus(program, programByProvinceByStatus)
        }
      }
    }

    return programByProvinceByStatus
  },
  responseBodyToMap(payload, programByProvince, programByProvinceByStatus){
    let result = [];

    if(payload && payload.length > 0 && programByProvince && programByProvince !== null){
      const provinceNames = Object.keys(programByProvince)
      const provinceNamesIsNotEmpty = provinceNames.length > 0
      if(provinceNamesIsNotEmpty){
        for (let index = 0; index < provinceNames.length; index++) {
          const provinceName = provinceNames[index];
          const province = programByProvince[provinceName]
          const cityNames = Object.keys(province)
          const firstCityName = cityNames[0]
          const firstCityData = province[firstCityName]
          const firstProgramInFirstCity = firstCityData[0]
          const coordinateString = firstProgramInFirstCity.pinLocation
          const coordinateObject = getCoordinateObject(coordinateString)
          const totalCompletedProgram = programByProvinceByStatus[provinceName].completedPrograms.length
          const totalOngoingProgram = programByProvinceByStatus[provinceName].ongoingPrograms.length
          const isOngoingOnly = totalCompletedProgram === 0
          const isCompletedOnly = totalOngoingProgram === 0

          if(provinceName !== 'N/A' && coordinateObject){
            result.push({
              name: provinceName,
              id: provinceName.toUpperCase().split(' ').join('_'),
              type: 'province',
              coordinate: coordinateObject,
              link: `/program?province=${provinceName}`,
              total: cityNames.length,
              markerType: 'program',
              markerSubType: isOngoingOnly ? 'ongoing' : isCompletedOnly ? 'completed' : false,
              noInteraction: true,
            })
          }
        }
      }
    }

    return nullCoordinateFilter(result)
  },
  responseBodyToNestedMap(payload, programByProvince, programByProvinceByStatus){
    let result = [];

    if(payload && payload.length > 0){
      // Proceed loop result above
      const provinceNames = Object.keys(programByProvince)
      const provinceNamesIsNotEmpty = provinceNames.length > 0
      if(provinceNamesIsNotEmpty){
        for (let index = 0; index < provinceNames.length; index++) {
          const provinceName = provinceNames[index];
          const province = programByProvince[provinceName]
          const cityNames = Object.keys(province)
          const firstCityName = cityNames[0]
          const firstCityData = province[firstCityName]
          const firstProgramInFirstCity = firstCityData[0]
          const coordinateString = firstProgramInFirstCity.pinLocation
          const coordinateObject = getCoordinateObject(coordinateString)
          const totalCompletedProgram = programByProvinceByStatus[provinceName].completedPrograms.length
          const totalOngoingProgram = programByProvinceByStatus[provinceName].ongoingPrograms.length
          const isOngoingOnly = totalCompletedProgram === 0
          const isCompletedOnly = totalOngoingProgram === 0

          if(provinceName !== 'N/A' && coordinateObject){
            result.push({
              name: provinceName,
              id: provinceName.toUpperCase().split(' ').join('_'),
              type: 'province',
              coordinate: coordinateObject,
              link: `/program?province=${provinceName}`,
              total: cityNames.length,
              markerType: 'program',
              markerSubType: isOngoingOnly ? 'ongoing' : isCompletedOnly ? 'completed' : false,
              metadata: [
                {
                  name: 'Ongoing Program',
                  count: totalOngoingProgram,
                  link: '/program'
                },
                {
                  name: 'Completed Program',
                  count: totalCompletedProgram,
                  link: '/program'
                },
              ],
              places: generateCities(provinceName, province)
            })
          }
        }
      }
    }

    return nullCoordinateFilter(result)

    /* Helpers */
    function generateCities(provinceName, province){
      const cities = []
      const cityNames = Object.keys(province)

      if(cityNames.length > 0){
        for (let index = 0; index < cityNames.length; index++) {
          const cityName = cityNames[index];
          const locations = province[cityName];
          const firstLocation = locations[0]
          const coordinateString = firstLocation.pinLocation
          const coordinateObject = getCoordinateObject(coordinateString)
          const totalCompletedProgram = programByProvinceByStatus[provinceName].city[cityName].completedPrograms.length
          const totalOngoingProgram = programByProvinceByStatus[provinceName].city[cityName].ongoingPrograms.length
          const isOngoingOnly = totalCompletedProgram === 0
          const isCompletedOnly = totalOngoingProgram === 0

          if(cityName !== 'N/A' && coordinateObject){
            cities.push({
              name: cityName,
              id: cityName.toUpperCase().split(' ').join('_'),
              type: 'city',
              coordinate: coordinateObject,
              total: locations.length,
              markerType: 'program',
              markerSubType: isOngoingOnly ? 'ongoing' : isCompletedOnly ? 'completed' : false,
              link: `/program?city=${cityName}`,
              metadata: [
                {
                  name: 'Ongoing Program',
                  count: totalOngoingProgram,
                  link: '/program'
                },
                {
                  name: 'Completed Program',
                  count: totalCompletedProgram,
                  link: '/program'
                },
              ],
              places: adaptLocations(locations)
            })
          }
        }
      }

      return nullCoordinateFilter(cities)
    }

    function adaptLocations(locations){
      let output = []

      if(locations.length > 0){
        for (let index = 0; index < locations.length; index++) {
          const location = locations[index];

          const {
            programId,
            pkLokasiActivityId,
            pinLocation,
            programName,
            content,
            isOngoing,
            jalan
          } = location

          const coordinateObject = getCoordinateObject(pinLocation)
          const markerType = isOngoing ? 'ongoing_program' : 'completed_program'

          if(programName !== 'N/A' && coordinateObject){
            output.push({
              name: programName,
              id: pkLokasiActivityId,
              type: 'headquarter',
              markerType,
              coordinate: coordinateObject,
              content,
              address: jalan,
              link: `/program/${programId}/detail`
            })
          }
        }
      }

      return output
    }
  },
  responseBodyToStatistic(input = {}){
    let output = {}

    if(input){
      const {
        beneficiariesByTahun,
        beneficiariesMen,
        beneficiariesWomen,
        beneficiariesMenDifable,
        beneficiariesWomenDifable,
        // lokasiProgramsByJalan,
        lokasiProgramsByKota,
        // lokasiProgramsByPinLocation,
        // lokasiProgramsByProvinsi,
        typeApproach,
        // typeAudience,
        typeIssues,
        typeOrganisasi,
        programTerdaftar,
        programByTahun = []
      } = input

      function breakToObject(array){
        const result = {}
        for (let index = 0; index < array.length; index++) {
          const d = array[index];
          const name = d[0]
          const value = d[1]
          result[name] = value
        }
        return result
      }

      const programByTahunObject = breakToObject(programByTahun)
      const tahunSorted = Object.keys(programByTahunObject).sort()
      const programByTahunSorted = tahunSorted.map(tahun => {
        return [tahun, programByTahunObject[tahun]]
      })

      const beneficiariesByTahunObject = breakToObject(beneficiariesByTahun)
      const tahunSorted1 = Object.keys(beneficiariesByTahunObject).sort()
      const beneficiariesByTahunSorted = tahunSorted1.map(tahun => {
        return [tahun, beneficiariesByTahunObject[tahun]]
      })

      output = {
        totalBeneficiaries: beneficiariesMen + beneficiariesWomen + beneficiariesMenDifable + beneficiariesWomenDifable,
        beneficiariesMen: beneficiariesMen + beneficiariesMenDifable,
        beneficiariesWomen: beneficiariesWomen + beneficiariesWomenDifable,
        organization: subAdapter.statistic.responseBodyToRender(typeOrganisasi, programTerdaftar),
        approach: subAdapter.statistic.responseBodyToRender(typeApproach, programTerdaftar),
        issues: subAdapter.statistic.responseBodyToRender(typeIssues, programTerdaftar),
        location: subAdapter.statistic.responseBodyToRender(lokasiProgramsByKota, programTerdaftar),
        province: subAdapter.statistic.responseBodyToRender(lokasiProgramsByKota, programTerdaftar),
        programByYear: subAdapter.statistic.responseBodyToRender(programByTahunSorted, programTerdaftar),
        beneficiariesByYear: subAdapter.statistic.responseBodyToRender(beneficiariesByTahunSorted, programTerdaftar),
      }
    }

    return output
  }
}

export default adapter

/* Helpers */
function reduceByProvince(program, holder){
  const result = {...holder}
  const {
    programId,
    judulActivity,
    deskripsiPendek,
    tanggalMulai,
    tanggalSelesai,
    statusActivity,
    lokasi,
  } = program;

  let isOngoing, isCompleted;

  if(autoStatusChecking){
    isOngoing = dayjs().isAfter(new Date(tanggalMulai)) && dayjs().isBefore(new Date(tanggalSelesai))
    isCompleted = dayjs().isAfter(new Date(tanggalSelesai))
  } else {
    isOngoing = statusActivity && statusActivity.id === ONGOING
    isCompleted = statusActivity && statusActivity.id === COMPLETED
  }

  if(lokasi && lokasi.length > 0){
    for (let index = 0; index < lokasi.length; index++) {
      const element = lokasi[index];

      const {
        provinsi,
        kota,
        // pkLokasiActivityId,
        // pinLocation
      } = element

      const locationWithProgramData = {
        ...element,
        programId,
        programName: {
          id: judulActivity[0],
          en: judulActivity[1]
        },
        content: {
          id: deskripsiPendek?.[0],
          en: deskripsiPendek?.[1]
        },
        isOngoing,
        isCompleted
      }

      const noProvinceYet = !result[provinsi]

      if(noProvinceYet){
        result[provinsi] = {
          [kota]: [locationWithProgramData]
        }
      } else {
        const noCityYet = !result[provinsi][kota]

        if(noCityYet){
          result[provinsi][kota] = [locationWithProgramData]
        } else {
          result[provinsi][kota].push(locationWithProgramData)
        }
      }
    }
  }

  return result
}

function reduceByProvinceByStatus(program, holder){
  const result = {...holder}
  const { programId, lokasi, statusActivity, tanggalMulai, tanggalSelesai } = program

  let isOngoing, isCompleted;

  if(autoStatusChecking){
    isOngoing = dayjs().isAfter(new Date(tanggalMulai)) && dayjs().isBefore(new Date(tanggalSelesai))
    isCompleted = dayjs().isAfter(new Date(tanggalSelesai))
  } else {
    isOngoing = statusActivity && statusActivity.id === ONGOING
    isCompleted = statusActivity && statusActivity.id === COMPLETED
  }

  if(lokasi && lokasi.length > 0){
    for (let index = 0; index < lokasi.length; index++) {
      const location = lokasi[index];

      const {
        provinsi,
        kota,
        // pkLokasiActivityId,
        // pinLocation
      } = location

      const locationWithProgramId = {...location, programId}
      const noProvinceYet = !result[provinsi]

      if(noProvinceYet){
        result[provinsi] = {
          ongoingPrograms: isOngoing ? [programId] : [],
          completedPrograms: isCompleted ? [programId] : [],
          city: {
            [kota]: {
              ongoingPrograms: isOngoing ? [programId] : [],
              completedPrograms: isCompleted ? [programId] : [],
              locations: [locationWithProgramId]
            }
          }
        }
      } else {
        const isOngoingAndNotSavedYet = isOngoing && result[provinsi].ongoingPrograms.includes(programId) === false
        const isCompletedAndNotSavedYet = isCompleted && result[provinsi].completedPrograms.includes(programId) === false

        if(isOngoingAndNotSavedYet){
          result[provinsi].ongoingPrograms.push(programId)
        } else if(isCompletedAndNotSavedYet) {
          result[provinsi].completedPrograms.push(programId)
        }

        const noCityYet = !result[provinsi].city[kota]

        if(noCityYet){
          result[provinsi].city[kota] = {
            ongoingPrograms: isOngoing ? [programId] : [],
            completedPrograms: isCompleted ? [programId] : [],
            locations: [locationWithProgramId]
          }
        } else {
          const isOngoingAndNotSavedOnCityYet = isOngoing && result[provinsi].city[kota].ongoingPrograms.includes(programId) === false
          const isCompletedAndNotSavedOnCityYet = isCompleted && result[provinsi].city[kota].completedPrograms.includes(programId) === false

          if(isOngoingAndNotSavedOnCityYet){
            result[provinsi].city[kota].ongoingPrograms.push(programId)
          } else if(isCompletedAndNotSavedOnCityYet) {
            result[provinsi].city[kota].completedPrograms.push(programId)
          }

          result[provinsi].city[kota].locations.push(locationWithProgramId)
        }
      }
    }
  }

  return result
}

function nullCoordinateFilter(result){
  const isNotNulls = []

  if(result && result.length > 0){
    for (let index = 0; index < result.length; index++) {
      const l = result[index];

      if(
          l.coordinate
          && l.coordinate.lat !== null
          && l.coordinate.lng !== null
          && !isNaN(l.coordinate.lat)
          && !isNaN(l.coordinate.lng)
        ){
        isNotNulls.push(l)
      }
    }
  }

  return isNotNulls
}
